module.exports = __webpack_public_path__ + "static/media/019-online-support.0b2f2fd9.svg";